export default __webpack_public_path__ + "static/media/start-your-journey.0633bfab.png";